import { render, staticRenderFns } from "./SecondaryGoalList.vue?vue&type=template&id=443e492d&scoped=true"
import script from "./SecondaryGoalList.vue?vue&type=script&lang=js"
export * from "./SecondaryGoalList.vue?vue&type=script&lang=js"
import style0 from "./SecondaryGoalList.vue?vue&type=style&index=0&id=443e492d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443e492d",
  null
  
)

export default component.exports